import type { HttpService } from "draivn-ui-domain";
import type { InjectionKey } from "vue";

export const API_SERVICE_INJECTION_KEY: InjectionKey<HttpService> =
  Symbol("API_SERVICE");
